__turbopack_context__.v({
  "modalContainer": "Modal-module-scss-module__8M2ThW__modalContainer",
  "modalContainerWithOutBackground": "Modal-module-scss-module__8M2ThW__modalContainerWithOutBackground",
  "modalFooter": "Modal-module-scss-module__8M2ThW__modalFooter",
  "modalHeader": "Modal-module-scss-module__8M2ThW__modalHeader",
  "modalLabel": "Modal-module-scss-module__8M2ThW__modalLabel",
  "modalMain": "Modal-module-scss-module__8M2ThW__modalMain",
  "modalOverlay": "Modal-module-scss-module__8M2ThW__modalOverlay",
  "modalTitle": "Modal-module-scss-module__8M2ThW__modalTitle",
});
